import React from "react";
import { Create, SimpleForm, TextInput, BooleanInput, SelectInput, ReferenceInput, LongTextInput } from "react-admin";

export const CouponCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <ReferenceInput label="Campaign" source="campaign" reference="campaigns">
          <SelectInput optionText="title" />
        </ReferenceInput>
        <BooleanInput source="expired"/>
        <TextInput source="code" label="Coupon code"/>
        <LongTextInput source="description" label="Coupon description"/>
      </SimpleForm>
    </Create>
  );
};
